import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import { LUXURY_ESCAPES } from 'constants/brands'
import config from 'constants/config'
import HeadData from 'components/Common/HeadData'

function CruiseHeadData() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  const headTitle = config.BRAND === LUXURY_ESCAPES
    ? intl.formatMessage({
        id: 'ipARwFQbBR',
        defaultMessage: 'Luxury Cruises',
        description: 'Page title for luxury cruises search page',
      })
    : intl.formatMessage({
        id: 'yUGYQjHpOU',
        defaultMessage: 'Cruises',
        description: 'Page title for cruises search page',
      })

  const description = config.BRAND === LUXURY_ESCAPES
    ? intl.formatMessage({
        id: 'PdpL6X6FiJ',
        defaultMessage: 'Embark on a life changing cruise. Curated by travel experts to save you time. Featuring luxury accommodation, select dining and exclusive inclusions.',
        description: 'Meta description for luxury cruises search page',
      })
    : undefined

  return <HeadData title={`${headTitle} - ${config.title} ${currentRegionCode}`} description={description} />
}

export default CruiseHeadData
